<template>
  <v-app>
    <app-headers :loggedIn="loggedIn && termsAndConditionsAccepted" />
    <template v-if="loggedIn && termsAndConditionsAccepted">
      <app-nav />
      <!-- <app-portal-context/> -->
      <GroupSelector />
      <app-announcements modifier="_mbxs _mtxs" />
    </template>
    <router-view />
    <app-footer />
    <cookie-policy />
  </v-app>
</template>

<script>
  import AppHeaders from '@sections/Headers.vue'
  import AppNav from '@sections/NavMain.vue'
  import AppFooter from '@organisms/Footer/Footer.vue'
  import AppAnnouncements from '@organisms/Announcements'
  import AppPortalContext from '@organisms/PortalContext';
  import CookiePolicy from '@sections/CookiePolicy.vue'
  import GroupSelector from '@organisms/GroupSelector.vue'
  import fetchable from '@mixins/fetchable'
  import { SESSION_HEALTH_CHECK } from '@store/modules/auth/actionTypes'
  import {
    executeGroupSearch,
    getParentGroupSettings
  } from '@/js/open-enrollment/oe-service-helpers'
  import { getEventRequestList } from '@/js/open-enrollment/create-event.helper'
  import { useStore } from '@vue3shims'
  import { computed, watch } from '@vue/composition-api'
  import { useGroupSelector } from '@composables/useGroupSelector'

  export default {
    setup() {
      const store = useStore()
      const { group, parentGroup } = useGroupSelector()
      const loggedIn = computed(() => store.getters['loggedIn'])
      const minimumAccess = computed(() => store.getters['minimumAccess'])
      const termsAndConditionsAccepted = computed(
        () => store.getters['termsAndConditionsAccepted']
      )
      
      const getGroupSettings = () => {
        if (parentGroup.value) {
          getParentGroupSettings({
            parentGroupCk: parentGroup.value.parentGroupCk
          }).then(groupSettings => {
            store.commit('groupSelector/SET_GROUP_SETTINGS', groupSettings)
          })
        }
      }


      const getEventRequests = async () => {
        // this logic was originally accessing a getter that does not exist
        //  If I understand the intent correctly, this should work
        if (store.getters['accountType'] === null) {
          let parentGroup = store.getters['groupSelector/parentGroup'];
          // console.log(`parentGroup`, parentGroup);
          if (parentGroup && parentGroup.parentGroupCk) {
            let locations = await getEventRequestList({
              parentGroupCk: parentGroup.parentGroupCk,
            });
          }
        }
      }

      watch(group, _ => {
        getGroupSettings()
        // as to why this is delayed?  No clue.
        //   imma leave it tho.  no idea what it might break.
        setTimeout(() => {
          getEventRequests()
        }, 500)
      })

      return {
        getEventRequests,
        getGroupSettings,
        loggedIn,
        minimumAccess,
        termsAndConditionsAccepted
      }
    },
    mixins: [fetchable],
    components: {
      AppHeaders,
      AppNav,
      AppFooter,
      AppAnnouncements,
      AppPortalContext,
      CookiePolicy,
      GroupSelector,
    },
    computed: {
      fetchers() {
        return [
          {
            action: SESSION_HEALTH_CHECK,
            // on pages with nested route views, this computed prop will get evaluated twice (eg: Forgot Password)
            // once before the $route has loaded, and again after. This was causing the session check to fire even
            // though loginRoute was set to true because because meta wasn't loaded yet. The litmus test for if the
            // $route info is valid is $route.name !== null
            shouldFetch:
              this.$route.name !== null &&
              !this.$route.meta.skipSessionHealthCheck &&
              this.$route.path !== '/page/terms' &&
              this.$route.path !== '/page/privacy-policy'
          }
        ]
      }
    }
  }
</script>
